import { Action, Reducer } from 'redux';
import { InsuranceSublineTypes, InsuranceSublineState, InsuranceSublineActionTypes } from './insuranceSublineTypes';
import { haskeyReducer } from '@/main/services/reducerUtils';

export const INITIAL_STATE: InsuranceSublineState = {
  insuranceSublines: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  },
  isolated: {}
};

const insuranceSublineReducer: Reducer<InsuranceSublineState> = (
  state: InsuranceSublineState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as InsuranceSublineActionTypes;

  switch (actionTypes.type) {
    case InsuranceSublineTypes.GET_INSURANCE_SUBLINES:
      const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducer) {
        return {
          ...state,
          isolated: {
            ...state.isolated,
            [actionTypes.payload.keyReducer]: {
              ...(state.isolated[actionTypes.payload.keyReducer] ??
                INITIAL_STATE.insuranceSublines),
              isLoading: true
            }
          }
        };
      }

      return {
        ...state,
        insuranceSublines: { ...state.insuranceSublines, isLoading: true }
      };
    case InsuranceSublineTypes.SAVE_INSURANCE_SUBLINES:
      const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducerSave) {
        return {
          ...state,
          isolated: {
            ...state.isolated,
            [actionTypes.payload.keyReducer]: {
              ...state.isolated[actionTypes.payload.keyReducer],
              isLoading: false,
              errorMessages: actionTypes.payload.errorMessages,
              isError: actionTypes.payload.isError,
              data: actionTypes.payload.data
            }
          }
        };
      }
      return {
        ...state,
        insuranceSublines: {
          ...state.insuranceSublines,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };     
    case InsuranceSublineTypes.RESET_REDUCER_INSURANCE_SUBLINES:
      return {
        ...state,
        insuranceSublines: INITIAL_STATE.insuranceSublines
      };
    default:
      return state;
  }
};

export default insuranceSublineReducer; 